export const environment = {
  production: true,
  apiURL: 'https://us-central1-test-project-187115.cloudfunctions.net/',
  firebase: {
    apiKey: "AIzaSyDNBZI2dkqsjQ2_DWev-q9f58N-YBsyxJ0",
    authDomain: "test-project-187115.firebaseapp.com",
    databaseURL: "https://test-project-187115.firebaseio.com",
    projectId: "test-project-187115",
    storageBucket: "test-project-187115.appspot.com",
    messagingSenderId: "1089098392630"
  }
};


// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/environments/environment.ts